import {
  Dialog,
  DialogContent,
  IconButton,
  Box,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import TicketDetailContent from './TicketDetailContent';

interface TicketDetailModalProps {
  ticketId: string | null;
  open: boolean;
  onClose: () => void;
  /** Modo solo lectura: oculta acciones (escalar/asignar/estado/comentarios/reabrir). */
  readOnly?: boolean;
}

export default function TicketDetailModal({ ticketId, open, onClose, readOnly }: TicketDetailModalProps) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth scroll="paper">
      <Box sx={{ position: 'absolute', right: 8, top: 8, zIndex: 1 }}>
        <IconButton onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </Box>
      <DialogContent dividers sx={{ p: 2, bgcolor: 'grey.50' }}>
        {ticketId && (
          <TicketDetailContent ticketId={ticketId} embedded onBack={onClose} readOnly={readOnly} />
        )}
      </DialogContent>
    </Dialog>
  );
}
